import { adminHttpClient } from '../commons/adminHttpClient'

export type EditEmailTemplateRequest = {
  id: string
  content: string
  subject: string
  productId?: number
}

const editEmailTemplate = (request: EditEmailTemplateRequest) => adminHttpClient.put('/EmailTemplates', request)

export default editEmailTemplate
